const constants = {
  MOBILE_WIDTH: 768,
  MIN_DESKTOP_WIDTH: 992,
};

const events = {
  NAV_OPENING: "nav_opening",
  BASKET_UPDATE: "basket_update",
  ORDER_UPDATE_START: "order_update_start",
  ORDER_UPDATE_END: "order_update_end",
  START_LOADING: "start_loading",
  STOP_LOADING: "stop_loading",
  SHOW_TICKET_BASKET_FAIL: "show_ticket_basket_fail",
  UPDATE_BASKET_BAR: "update_basket_bar",
  SET_BASKET_EXPIRY_TIMER: "set_basket_expiry_timer",
  REPORT_ERROR: "report_error",
  BASKET_NOTIFICATION: "basket-notification",
  R4R_REGISTERED_CHECK: 'rewards_registered',
  R4R_REFRESH: 'rewards_refresh',
};

const classes = {
  HIDDEN: "u-hidden",
  LOADING: "is-loading",
};

const attributes = {
  price: "data-price",
  quantity: "data-quantity",
  itemTracking: "data-item-tracking",
  orderTracking: "data-order-tracking",
  trackingBeginCheckout: "data-track-begin-checkout",
  itemUpgradeTracking: "data-item-upgrade-tracking",
};

const ecommerceEvents = {
  view_item_list: "view_item_list",
  add_to_cart: "add_to_cart",
  remove_from_cart: "remove_from_cart",
  view_cart: "view_cart",
  begin_checkout: "begin_checkout",
  add_shipping_info: "add_shipping_info",
  add_payment_info: "add_payment_info",
};

export { constants, events, classes, ecommerceEvents, attributes };
